import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Rarity } from '#src/__generated__/globalTypes.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { EssenceBalance } from '#src/components/balance/EssenceBalance/index.tsx';
import { GemsBalance } from '#src/components/commonGame/GemsBalance/index.tsx';
import { ANY_SPORT_SERIES_MARKET } from '#src/constants/__generated__/routes.ts';
import { useConfigContext } from '#src/contexts/config/index.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { getCommonCardShardsCount } from '#src/lib/currentUser/index.tsx';

import type { MobileSeriesUserCurrencies_cardSet } from './__generated__/index.graphql.ts';

export const MobileSeriesUserCurrencies = ({
  variant,
}: {
  variant?: 'vertical' | 'horizontal';
}) => {
  const { generateSportContextPath } = useSportContext();
  const { currentUser } = useCurrentUserContext();
  const { cardSet } = useConfigContext();
  const currentCardSet = cardSet?.currentSet ?? cardSet?.nextSet;

  const shardsBalance = getCommonCardShardsCount(
    currentUser,
    currentCardSet?.slug
  );

  const showGems = !currentUser?.anyUserSportProfile?.proUnlocked;

  return (
    <Horizontal>
      {!!showGems && (
        <GemsBalance
          balance={currentUser?.gemsBalances[0]?.amount || 0}
          variant={variant}
        />
      )}
      <EssenceBalance
        variant={variant}
        value={shardsBalance}
        rarity={Rarity.common}
        cardSet={currentCardSet}
        to={generateSportContextPath(ANY_SPORT_SERIES_MARKET)}
      />
    </Horizontal>
  );
};

MobileSeriesUserCurrencies.fragments = {
  cardSet: gql`
    fragment MobileSeriesUserCurrencies_cardSet on CardSet {
      slug
      ...EssenceBalance_cardSet
    }
    ${EssenceBalance.fragments.cardSet}
  ` as TypedDocumentNode<MobileSeriesUserCurrencies_cardSet>,
};
